import { useRef } from 'react';

export default function useSingle<T>(fn: () => T) {
  const ref = useRef<T>();

  if (!ref.current) {
    ref.current = fn();
  }

  return ref.current;
}
